export default {
    title: `Essentials`,
    subTitle: `Economic activity as viewed by Alan Mudie, Head of Investment Strategy at Societe Generale Private Banking.`,
    keyFigures: [
          {
            figure: 15,
            suffix: `%`,
            content: `According to the OECD, this is the contribution improved air quality made to GDP growth in Europe (between 2010-2015). This is the first study which confirms that air pollution leads to a drop in economic activity through absenteeism and a reduction in worker output. The results suggest that public policies to reduce air pollution can make a positive contribution to economic growth.`,
            source: `Source: <a href="http://oecd-ilibrary.org" target="_blank">oecd-ilibrary.org</a>`,
            noMarge: true,
        },

        {
            prefix: `$`,
            figure: 316,
            suffix: `billion`,
            content: `Africa could increase its GDP by $316 billion (+10%) by 2025 if each country rose to the level of South Africa, the country with the highest level of gender equality on the continent. At the rate of current progress, Africa will take more than 140 years to reach gender parity.`,
            source: `Source: <a href="http://mckinsey.com" target="_blank">mckinsey.com</a>, Nov 2019.`,
            noCollapse: true,
        },

        {
            prefix: `$`,
            figure: 75,
            suffix: `/t`,
            content: `it would take a tax of $75 per tonne of carbon, compared to the current figure of $2, to successfully limit the rise in global temperature to 2°C above pre-industrial levels, as stipulated in the Paris Agreements.`,
            source: `Source: <a href="http://IMF.org" target="_blank">IMG.org</a>, Dec. 2019.`,
            noCollapse: true,
            noMarge: true,
        },

        {
            figure: 73.6,
            figureDecimals: 1,
            suffix: `%`,
            content: `According to a study by Eurostat, the employment rate of people aged 20 to 64 in the euro zone reached its highest level ever (73.6%) in 2019. When the indicator was first published, in 2000, the employment rate was 68%.`,
            source: `Source: <a href="http://ec.europa.eu" target="_blank">ec.europa.eu</a>, May 2019.`,
            noCollapse: true,
            noMarge: true,
        },
        {   
            prefix: `$`,
            figure: 2026,
            suffix: `billion`,
            content: `This is the highest market capitalization in the history of the financial markets. The record, reached on 16th December 2019, goes to Saudi Aramco, the former national company charged with exploiting the oil reserves of Saudi Arabia.`,
            source: `Source: BNN Bloomberg, Dec. 2019.`,
            noCollapse: true,
        },

        {
            figure: 60,
            suffix: `%`,
            content: `According to an analysis of Uber journeys made in the United States, more than 15% of customers tip, even though the payments are anonymous and do not confer any advantage on the traveller. Almost 60% of people never tip, and only 1% do so systematically.`,
            source: `Source: <a href="http://nber.org" target="_blank">nber.org</a>, Dec. 2019.`,
            noCollapse: true,
            noMarge: true,
        },

    ]
};

